import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEgresoInsumos = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'egreso_stock',
        name: 'Egreso de insumos',
        component: ViewEgresoInsumos,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
